require('./gallery.module');
require('./gallery.service');
require('./gallery_edit.controller');
require('./gallery_show.controller');